import React, { memo } from 'react';
export function Tomos() {
  const tomos = [{
    number: 1,
    emoji: '🩺',
    title: 'Consulta clínica efectiva',
    description: 'Anamnesis, consentimiento, registro de sesión y devolución a familias.'
  }, {
    number: 2,
    emoji: '🧠',
    title: 'Intervención psicopedagógica',
    description: 'Estrategias, seguimiento y propuestas por áreas cognitivas.'
  }, {
    number: 3,
    emoji: '📋',
    title: 'Evaluación inteligente',
    description: 'Screening, listas de cotejo, informes editables y semáforos de alerta.'
  }, {
    number: 4,
    emoji: '✏️',
    title: 'Lectoescritura desde cero',
    description: 'Conciencia fonológica, grafomotricidad, fichas y progresiones por nivel.'
  }, {
    number: 5,
    emoji: '📖',
    title: 'Proceso de alfabetización',
    description: 'Actividades graduadas, recursos semanales y registro de avances.'
  }, {
    number: 6,
    emoji: '🎲',
    title: 'Juegos terapéuticos',
    description: 'Juegos por objetivo, fichas de juego y materiales imprimibles.'
  }];
  return <section className="w-full py-16 bg-[#111111] font-['Open_Sans',_sans-serif] pt-[0px] pb-[0px]" data-id="element-247">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-248">
        <div className="text-center mb-6" data-id="element-249">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-250">
            Lo que recibís
          </h2>
        </div>

        <div className="max-w-3xl mx-auto mb-6 space-y-2" data-id="element-251">
          {tomos.map(tomo => <div key={tomo.number} className="flex items-center gap-5 bg-[#1A1A1A] border border-[#D4A843]/15 rounded-xl px-6 py-5 transition-all duration-200 hover:border-[#D4A843]/40 hover:bg-[#1E1E1E]" data-id="element-252">
              <span className="text-3xl flex-shrink-0" data-id="element-253">{tomo.emoji}</span>
              <div className="flex-1 min-w-0" data-id="element-254">
                <h3 className="font-bold text-white text-lg leading-tight" data-id="element-255">
                  <span className="text-[#D4A843] mr-2 text-sm font-semibold" data-id="element-256">
                    TOMO {tomo.number}
                  </span>
                  {tomo.title}
                </h3>
                <p className="text-gray-400 text-sm mt-1 leading-relaxed" data-id="element-257">
                  {tomo.description}
                </p>
              </div>
            </div>)}
        </div>

        <div className="flex justify-center" data-id="element-258">
          <a href="#ofertas" className="inline-block bg-[#D4A843] hover:bg-[#B8912E] text-white font-bold px-8 py-4 rounded-lg transition-all duration-200 hover:scale-105 text-[16px] shadow-[0_0_20px_rgba(212,168,67,0.2)]" data-id="element-259">
            🧮→ Quiero el Megapack
          </a>
        </div>
      </div>
    </section>;
}